import CalendarSection from "../../components/CalendarSection";

export default function YouCalendars() {
  return (
    <main className="max-w-3xl mx-auto px-6 md:px-12 py-8 md:py-12" data-testid="you-calendars-page">
      <div className="mb-2">
        <p className="label-tag mb-3">You · Calendars</p>
        <h1 className="heading-h1 text-4xl sm:text-5xl mb-2">Calendars.</h1>
        <p className="text-sand-600 text-base mt-3">Subscribe to your trips from Google Calendar, and let the AI read your schedule.</p>
        <div className="divider-strong mt-4" />
      </div>
      <CalendarSection />
    </main>
  );
}
